// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const salamence_mega: PokeData = {
  "id": 10089,
  "name": "salamence-mega",
  "height": 18,
  "weight": 1126,
  "base_experience": 315,
  "types": [
    PokeType.DRAGON,
    PokeType.FLYING
  ],
  "api_moves": [
    "fly",
    "headbutt",
    "double-edge",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "rage",
    "focus-energy",
    "protect",
    "scary-face",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "thunder-fang",
    "fire-fang",
    "zen-headbutt",
    "dragon-tail"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "protect",
    "scary-face",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "thunder-fang",
    "fire-fang",
    "zen-headbutt"
  ],
  "evolution_chain": {
    "id": 191,
    "item": null,
    "species": [
      {
        "name": "bagon",
        "order": 401,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "shelgon",
        "order": 402,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 371,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "salamence",
        "order": 403,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 372,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 131,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
